import { Grid } from '@mui/material';
import { useAsync } from 'react-async-hook';

import { investorApiClient } from 'api';
import { PageContainer } from 'components/UI';
import { UncompletedTaskGroups, UnpaidCommitmentsAlert } from 'components/card-widgets';
import { useCurrencySelection } from 'providers/currency-selection';

import { StatisticHeader } from './StatisticHeader';
import { InvestmentActivity } from './InvestmentActivity';
import { InvestmentSummary } from './InvestmentSummary';
import { ExpectedRepayments } from './ExpectedRepayments';
import { NetReturnHistory } from './NetReturnHistory';
// import { DealsMatchesFilters } from './DealsMatchesFilters';
import { PortfolioAllocation } from './PortfolioAllocation';

export const DashboardPage = () => {
  const { selectedCurrency } = useCurrencySelection();

  const { result: generalStatistics, loading } = useAsync(async () => {
    // prettier-ignore
    const { data } = await investorApiClient.investors.investorApiControllerGetGeneralStatistics();
    return data;
  }, []);

  return (
    <PageContainer>
      <Grid container spacing={4}>
        <UncompletedTaskGroups
          wrapper={(body) => (
            <Grid item xs={12}>
              {body}
            </Grid>
          )}
        />

        <UnpaidCommitmentsAlert
          wrapper={(body) => (
            <Grid item xs={12}>
              {body}
            </Grid>
          )}
        />

        {selectedCurrency && (
          <StatisticHeader
            generalStatistics={generalStatistics}
            loading={loading}
            currency={selectedCurrency}
          />
        )}

        <Grid item xs={12}>
          <InvestmentActivity />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <DealsMatchesFilters />
        </Grid> */}

        {selectedCurrency && (
          <>
            <Grid item xs={12}>
              <PortfolioAllocation currency={selectedCurrency} />
            </Grid>

            <Grid item xs={12} lg={6}>
              <InvestmentSummary currency={selectedCurrency} />
            </Grid>

            <Grid item xs={12} lg={6}>
              <ExpectedRepayments currency={selectedCurrency} />
            </Grid>

            <Grid item xs={12} lg={6}>
              <NetReturnHistory currency={selectedCurrency} />
            </Grid>
          </>
        )}
      </Grid>
    </PageContainer>
  );
};
